import { URL_API } from "../../../general/init/url";

export const API_CABANG_GET_LIST_OUTLET = URL_API + "/api/CabangOutlet";
